import { createContext } from "react";
var ModalsContext = createContext({
    modals: [],
    openModal: function (id, title, modal, preventClose) { },
    closeModal: function (id) { },
});
export default ModalsContext;
//# sourceMappingURL=ModalsContext.js.map